import { Fragment, useMemo } from "react";
import { BasicTable } from "../common/BasicTable";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../common/LoadingPage";
import ErrorPage from "../common/ErrorPage";
import { useSeatSearchContext } from "../../store/SeatSearchContextProvider";
import { SeatFilterMap } from "./FilterComponents/FilterConstants";
// import FilterDown from '../../../assets/images/FilterDown.svg';
import { useSeatData } from "../../store/MasterDataContext";
import { FilterButton } from "./SearchForm";
import { checkApi } from "../../Authentication/AxiosInstance";
import { SeatsMobileFirst } from "./SeatsMobileFirst";

export const Seats = () => {
  const filterMap = SeatFilterMap;
  console.log(filterMap);
  const { seatMasterData } = useSeatData(); // Ensure you use seatMasterData, since useData defines masterData.
  const searchObject = useSeatSearchContext().seatSearchArray;
  console.log(searchObject);
  // Combine all objects into one
  const getSearchKey = (searchObject) => JSON.stringify(searchObject);
  console.log(getSearchKey(searchObject))
  const searchArray = [searchObject];
  console.log(searchArray);

  const fetchSeats = async () => {
    console.log(searchArray);
    const searchParams = createSearchParams(searchArray);
    // Convert URLSearchParams to plain object for axios
    const params = Object.fromEntries(searchParams);
    const res = await checkApi.get('/capzone/seats/', { params });
    return res.data;
  };

  const { data, error, status } = useQuery({
    queryKey: ["seatsData", getSearchKey(searchObject)],
    queryFn: fetchSeats,
    throwOnError: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
  console.log(searchArray)
  console.log(data);
  console.log(status, error);
  const nullFilter = (row, columnId, filterValue) => {
        const cellValue = row.getValue(columnId);

        if (filterValue.toLowerCase() === "null" || filterValue.toLowerCase() === "empty") {
          return cellValue === null || cellValue === undefined || cellValue === "";
        }

        return String(cellValue).toLowerCase().includes(filterValue.toLowerCase());
  };
  
  const columns = useMemo(() => {
    console.log(data);
    if (!data || data.length === 0) return []; // Ensure data exists before trying to access it
    const v_allocationBoard = data[0]?.s001_allocationboard;
    const baseColumns = [
      {
        header: "Institute",
        footer: "Institute",
        accessorFn: (row) => `(${row.s001_instcode}) ${row.s001_instname}`,
        minSize: 600,
      },
      {
        accessorFn: (row) => (row.s001_branchcode !== null ? `(${row.s001_branchcode}) ${row.s001_branchname}` : `${row.s001_branchname}`),
        header: "Branch",
        footer: "Branch",
        minSize: 400,
      },
      {
        accessorKey: "s001_insttype",
        header: "Institute Type",
        footer: "Institute Type",
        cell: (row) => {
          return <div className="text-center">{row.getValue("s001_statequota")}</div>;
        },
        filterFn: nullFilter, // Apply the custom nullFilter to enable user to search by null or empty values
      },
      {
        accessorKey: "s001_statecriteria",
        header: "State Criteria",
        footer: "State Criteria",
        cell: (row) => {
          return <div className="text-center">{row.getValue("s001_statecriteria")}</div>;
        },
      },
     
    ];
    if (v_allocationBoard !== 'COMEDK') {
        baseColumns.push (
            {
              accessorKey: "s001_caste",
              header: "Category",
              footer: "Category",
              cell: (row) => {
                return <div className="text-center">{row.getValue("s001_category")}</div>;
              },
              enableColumnFilter: false, // disable column filtering for this column
            },
            {
              accessorKey: "s001_gender",
              header: "Gender",
              footer: "Gender",
              cell: (row) => {
                return <div className="text-center">{row.getValue("s001_gender")}</div>;
              },
              enableColumnFilter: false, // disable column filtering for this column
            },
            {
              accessorKey: "s001_common",
              header: "Common",
              footer: "Common",
              cell: (row) => {
                return <div className="text-center">{row.getValue("s001_common")}</div>;
              },
              filterFn: nullFilter, // Apply the custom nullFilter to enable user to search by null or empty values
            },
        );
      }
    if (v_allocationBoard === 'MHTCET') {
          baseColumns.push (
            {
              accessorKey: "s001_summary",
              header: "Summary",
              footer: "Summary",
              cell: (row) => {
                return <div className="text-center">{row.getValue("s001_summary")}</div>;
              },
              filterFn: nullFilter, // Apply the custom nullFilter to enable user to search by null or empty values
            },
          );
      }
    baseColumns.push (
            {
              accessorKey: "s001_vacantseats",
              header: "Vacant Seats",
              footer: "Vacant Seats",
              cell: (row) => {
                return <div className="text-center">{row.getValue("s001_vacantseats")}</div>;
              },
            },
          );
    return baseColumns;
    
  }, [data]);

  function createSearchParams(params) {
    const searchParams = new URLSearchParams();
    params.forEach((item) => {
      Object.keys(item).forEach((paramKey) => {
        if (item[paramKey]) {
          const findSeatParent = filterMap.find((seatKey) => seatKey.parent === paramKey);
          const paramSeatName = findSeatParent ? findSeatParent.seats : null;
          if (paramSeatName) {
            searchParams.append(paramSeatName + "__icontains", item[paramKey]);
            console.log(searchParams);
          }
        }
      });
    });
    return searchParams;
  }

  function matchedRow() {
    console.log(seatMasterData);
    const filterRow = seatMasterData.filter((item) => {
      return Object.keys(searchObject).every((key) => {
        let itemValue = item[key === "category" ? "caste" : key];
        let searchValue = searchObject[key];

        // Normalize undefined and null values
        itemValue = !itemValue && itemValue !== 0 && itemValue !== false ? null : itemValue;
        searchValue = !searchValue && searchValue !== 0 && searchValue !== false ? null : searchValue;

        return itemValue === searchValue;
      });
    
    });

    // Check if any rows matched and handle accordingly
    if (filterRow.length > 0) {
      console.log(filterRow)
      //return the sum of vacantseats for that filter group
      const totalVacantSeats = filterRow.reduce((sum, row) => { 
        return sum + (Number(row.vacantseats) || 0);
      }, 0);
      return totalVacantSeats;
    } else {
      console.log("No matching rows found.");
      return undefined; // Or handle as appropriate if no matches found
    }
  }
  const ShowSearchCriteria = () => {
    return Object.entries(searchObject).map(([key, value]) => {
      console.log(key, value);
      if (value !== null && value !== undefined) {
        return (
          <div key={key} className="flex">
            <label className="flex m-1 pr-2 w-full rounded border-2 border-cave-500 align-middle  ">
              <span className="m-1 text-secondary-900 text-xs font-bold">{value} &#x2713;</span>
            </label>
          </div>
        );
      }
    });
  };

  const formatReleaseDate = (dateString) => {
  if (!dateString) return "No Date"; // Handle null/undefined

  const dateObj = new Date(dateString);
  return dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  
};
  
  return (
    <Fragment>
      {/* Mobile View - Only visible on mobile */}
      <div className="seats-mobile-container">
        <SeatsMobileFirst />
      </div>

      {/* Desktop View - Original, only visible on desktop */}
      <div className="seats-desktop-container">
        <div className="flex w-full">
          {status === "pending" ? (
            <div className="flex w-full justify-center items-center">
              <LoadingPage invokedFrom="seats" />
            </div>
          ) : status === "error" ? (
            <div className="w-full">
              <ErrorPage 
                emessage={
                  error?.response?.data?.detail || 
                  error?.response?.data?.message || 
                  error?.message || 
                  "An error occurred while fetching seats data"
                } 
                invokedFrom="seats" 
              />
            </div>
          ) : (
            data && data.length > 0 && (
              <div>
                <div className="flex flex-row space-x-4">
                  <FilterButton className="w-1/3" optionType="seats" />
                  <div className="flex flex-col">
                    <div className="flex flex-row justify-between items-center w-full h-8 ">
                      <div className="flex items-stretch">
                        {/* <img src={FilterDown} alt="FilterDown" className="flex h-8 m-0" /> */}
                        📌
                        <ShowSearchCriteria/>
                      </div>
                      <div>
                        <label className="m-1 p-4 text-end font-bold text-lg ">
                          <span className="text-red-900">{matchedRow()} </span>
                          <span className="text-blue-900">{" available seats !!!"}</span>
                        </label>
                      </div>
                    </div>
                    <div className = "m-1 text-secondary-900 text-base font-bold">Release Date: {formatReleaseDate(data[0].s001_releasedate)}</div>
                    <div className="flex flex-row space-x-4">
                      <BasicTable className="w-2/3" data={data} columns={columns} />
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {/* Custom Styles for Mobile/Desktop Display */}
      <style>{`
        /* Mobile View - Show on mobile, hide on desktop */
        .seats-mobile-container {
          display: block;
        }
        @media (min-width: 640px) {
          .seats-mobile-container {
            display: none !important;
          }
        }
        
        /* Desktop View - Hide on mobile, show on desktop */
        .seats-desktop-container {
          display: none;
        }
        @media (min-width: 640px) {
          .seats-desktop-container {
            display: block !important;
          }
        }
      `}</style>
    </Fragment>
  );
};
